export function nvpToChart(items) {
    return {
        labels: items.map(x => x.name),
        datasets: [{
                values: items.map(x => x.value),
            }]
    };
}
